import auth from "../../middlewares/auth";
export const membersAdminRoute = [
    {
        path: '/members/admin',
        component: () => import(/* webpackChunkName: "members" */ '../../views/members/admin/AdminList'),
        name: 'members_admin',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/members/admin/add',
        component: () => import(/* webpackChunkName: "members" */ '../../views/members/admin/AdminForm'),
        name: 'member_admin_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/members/admin/edit/:id',
        component: () => import(/* webpackChunkName: "members" */ '../../views/members/admin/AdminForm'),
        name: 'member_admin_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    }
];